import { render, staticRenderFns } from "./BatchDialog.vue?vue&type=template&id=a95b4d38&"
import script from "./BatchDialog.vue?vue&type=script&lang=js&"
export * from "./BatchDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports